module.exports = __webpack_public_path__ + "img/accessory_shoe_04.2643ca18.svg";